import Vue from 'vue'
 
export let  URL_BASE="https://telemartin.com/BACKEND/";


import 'sweetalert2/dist/sweetalert2.min.css';
Vue.mixin({
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
    created(){
     // Listen for our custom event from the SW registration
    // document.addEventListener('swUpdated', this.updateAvailable, { once: true })

    // // // Prevent multiple refreshes
    // navigator.serviceWorker.addEventListener('controllerchange', () => {
    //   if (this.refreshing) return
    //   this.refreshing = true
    // //   // Here the actual reload of the page occurs
    //   window.location.reload()
    // });
    ///fin service worker

        //si se desea que el metodo inicie inmediatamente recuerda poner opciones para inicializarlos;
        var myId=this.$options.id;
        if(myId){
           // console.log("info desde el global mixin");
            this.inputValidoInvalido(myId);
        }
        // this.verificandoToken();
    },
    //metodos globales
    methods:{
      updateAvailable(event) {
        // console.log(event)
        this.registration = event.detail
        this.updateExists = true
      },
      refreshApp() {
        this.updateExists = false
        // Make sure we only send a 'skip waiting' message if the SW is waiting
        if (!this.registration || !this.registration.waiting) return
        // send message to SW to skip the waiting and activate the new SW
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      },
        URL_BASE(){
          return URL_BASE;
        },
        notificacion(type,titulo,text,group=""){
          this.$notify({
            group,
            title:titulo,
            text,
            type,
          })
      },
      
        advertencia(text){
          this.notificacion('warn',"<h5><b> <i class='fas fa-exclamation-circle fa-lg'></i>  ¡Advertencia!</b></h5>","<h6>"+text+"</h6>");
      },
        exito(text){
          this.notificacion('success',"<h5><b> <i class='fas fa-check fa-lg'></i>  ¡Exito!</b></h5>","<h6>"+text+"</h6>");
      },
        error(text){
          this.notificacion('error',"<h5><b> <i class='fas fa-exclamation-triangle fa-lg'></i>  ¡ ERROR !</b></h5>","<h6>"+text+"</h6>");
      },
        informacion(text){
          this.notificacion(''," <h5 class='text-center'><b> <i class='fas fa-info-circle fa-lg'></i>  AVISO</b></h5>","<h6 class='text-center'>"+text+"</h6>","info");
      },
        verificandoToken(){
          if(this.$store.state.auth){
            // setTimeout(() => {
           
            // }, 5000); 
            console.log("tokena a espirar");
            setInterval(() => {
              alert('token a punto de caducar');
            }, 5000);
            //3 segundo
          }
         
      },
      procesoCompletado(){
          this.$swal('Proceso completado', '', 'success')
      },
      
        url_amigable(string) {
          var str = string;
          str = str.toLowerCase();
          //Rememplazamos caracteres especiales latinos
          var find = ['á', 'é', 'í', 'ó', 'ú', 'ñ'];
          var replace = ['', '', '', '', '', ''];
          var url = str.replace(find, replace);
          var find2 = [' ', '&', '\r\n', '\n', '+'];
          url = url.replace(find2, '-');
          url = url.replace(/['"]+/g, '');
          var fixed = url.replace(/\s+/g, '-');
          fixed = fixed.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
          fixed =  fixed.replace(/[¿?!¡]+/g, '');
          return fixed;
        },

     
         isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
          } else {
            return true;
          }
        },
        mesesNumerosToLetras(numero){
          switch(numero){
            case "1": return "Enero"; break;
            case "2": return "Febrero"; break;
            case "3": return "Marzo"; break;
            case "4": return "Abril"; break;
            case "5": return "Mayo"; break;
            case "6": return "Junio"; break;
            case "7": return "Julio"; break;
            case "8": return "Agosto"; break;
            case "9": return "Setiembre"; break;
            case "10": return "Octubre"; break;
            case "11": return "Noviembre"; break;
            case "12": return "Diciembre"; break;
          }
        }
              
    },
  
});
